import { Injectable, OnDestroy } from '@angular/core';
import { SiteSecuritySetting } from '../../shared/model/site-security-settings.model';
import { filter, Subscription } from 'rxjs';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthContextService implements OnDestroy {
  flowType: string;
  alternativeAuthMethods: any[];
  siteSecuritySetting: SiteSecuritySetting;
  private _returnUrl: string;
  private _referralCode: string;
  private queryParamsSub$: Subscription;
  userTermsChecked = false;
  userTermsDisabled = false;

  constructor(
    private stateStorageService: StateStorageService,
    private router: Router
  ) {
    this.queryParamsSub$ = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.updateParams());
    // Initial parameter extraction  
    this.updateParams();
  }

  private updateParams(): void {
    const params = this.router.routerState.snapshot.root.queryParamMap;
    this._returnUrl = params.get('returnUrl');
    this._referralCode = params.get('referralCode');
  }

  get returnUrl(): string {
    return this._returnUrl || this.stateStorageService.getUrl() || '/home';
  }

  set returnUrl(value: string) {
    this._returnUrl = value;
  }

  get referralCode(): string {
    return this._referralCode;
  }

  clear() {
    this._returnUrl = null;
    this._referralCode = null;
  }

  ngOnDestroy() {
    this.queryParamsSub$?.unsubscribe();
  }
}